module.exports = __webpack_public_path__ + "img/claudia-ifrim.2f60f379.jpg";